import { defineNuxtRouteMiddleware } from '#imports'
import { asRouteMiddleware, requireAuthOrGoHome } from '@utils/route-guards'

export default defineNuxtRouteMiddleware(asRouteMiddleware(requireAuthOrGoHome))
